import BeeAutocomplete from './autocomplete.vue'

BeeAutocomplete.install = (Vue) => {
  Vue.component(BeeAutocomplete.name, BeeAutocomplete)
}

export default BeeAutocomplete



// WEBPACK FOOTER //
// ./src/components/autocomplete/index.js